import { useState } from "react";
import { ImageIcon, ListTodo } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";
import { fmtDateTime } from "../../../lib/format";
import { errMsg, openFile } from "../../../lib/xutil";
import { useApi } from "../../customer/hooks";
import { PageHead, btnGhost, btnPrimary, chip } from "../../../components/common/Page";
import { EmptyState, SkeletonBlock } from "../../../components/common/EmptyState";
import { useConfirm } from "../../../components/common/ConfirmDialog";

export default function OfficeTasks() {
  const { t } = useI18n();
  const confirm = useConfirm();
  const [status, setStatus] = useState("open");
  const r = useApi("officeTasks", "/staff/deliveries/tasks/list", { status }, { staleTime: 0 });
  const resolve = async (task) => {
    const note = await confirm({ title: t("x.tasks.resolveTitle"), body: task.customer_name, input: { label: t("x.tasks.resolution"), minLength: 2 }, confirmLabel: t("x.tasks.resolve") });
    if (!note) return;
    try { await api.post(`/staff/deliveries/tasks/${task.id}/resolve`, { note }); toast.success(t("x.tasks.resolved")); r.refetch(); } catch (e) { toast.error(errMsg(t, e)); }
  };
  return (
    <div className="space-y-5" data-testid="tasks-page">
      <PageHead title={t("x.tasks.title")} sub={t("x.tasks.sub")}>
        {["open", "done"].map((k) => <button key={k} type="button" className={chip(status === k)} onClick={() => setStatus(k)} data-testid={`tasks-filter-${k}`}>{t(`x.tasks.${k}`)}</button>)}
      </PageHead>
      {r.isLoading ? <SkeletonBlock className="h-48" /> : !r.data?.length ? <EmptyState icon={ListTodo} title={t("x.tasks.empty")} testId="tasks-empty" /> : (
        <ul className="space-y-3" data-testid="tasks-list">
          {r.data.map((task) => (
            <li key={task.id} className="flex flex-wrap items-start gap-3 rounded-2xl bg-white p-4 shadow-sm" data-testid={`task-${task.id}`}>
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-navy">{t(`x.route.issueT.${task.type}`)} · {task.customer_name}</p>
                <p className="text-xs text-slate-500">{task.doc_no} · {fmtDateTime(task.created_at)} · {t("x.tasks.by", { name: task.created_by_name })}{task.item_code ? ` · ${task.item_code}` : ""}</p>
                {task.note && <p className="mt-1 text-sm text-navy">{task.note}</p>}
                {task.resolution && <p className="mt-1 text-sm text-brand">✓ {task.resolution}</p>}
              </div>
              <div className="flex gap-2">
                <button type="button" onClick={() => openFile(task.photo_file_id).catch(() => toast.error(t("common.error")))} className={`${btnGhost} px-3`} data-testid={`task-photo-${task.id}`}><ImageIcon className="h-4 w-4" />{t("x.tasks.photo")}</button>
                {task.status === "open" && <button type="button" onClick={() => resolve(task)} className={btnPrimary} data-testid={`task-resolve-${task.id}`}>{t("x.tasks.resolve")}</button>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
